import { forwardRef } from 'react';
import {
  FaIcon,
  ListButton,
  Resource,
  useMarkResourceAsRead,
} from '@fe-learner-common';
import { faArrowRight } from '@fortawesome/pro-regular-svg-icons/faArrowRight';
import { ResourceListItemProps } from './ResourceListItem';

export const Detail = forwardRef<
  HTMLButtonElement,
  Omit<ResourceListItemProps, 'container'>
>(({ resource, onResourceClick, participationId, texts, ...rest }, ref) => {
  const { mutate: markAsRead } = useMarkResourceAsRead({
    resourceId: resource.rid,
    participationId,
  });
  return (
    <ListButton
      role="article"
      className="flex items-center justify-between gap-x-4 overflow-hidden p-3"
      ref={ref}
      onClick={() => {
        onResourceClick(resource.rid);
        markAsRead();
      }}
      aria-label={texts.groupTypes[resource.groupType]}
      {...rest}
    >
      <Resource
        resourceId={resource.rid}
        title={resource.material.webTitle}
        groupType={resource.groupType}
        thumbnail={resource.material.thumbnail}
        tags={resource.tags}
        isNew={resource.newResource}
        texts={texts}
      />
      <FaIcon
        className="m-2 text-neutral-500 max-md:mb-auto"
        width={16}
        height={16}
        icon={faArrowRight}
      />
    </ListButton>
  );
});

Detail.displayName = 'DetailListItem';
